/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @author Viacheslav Smalenski
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { fonts, icons as themeIcons } from '@theme/index';

interface IImg {
    width?: string;
    height?: string;
    src?: string;
    opacity?: number;
    margin?: string;
}

export const ImgStyled = styled.div<IImg>`
    width: ${(props) => props.width};
    height: ${(props) => props.height || props.width};
    background: url(${(props) => props.src}) no-repeat center center;
    background-size: cover;
    box-sizing: border-box;
    opacity: ${(props) => props.opacity || 1};
    margin: ${(props) => props.margin ?? ''};

    &.pointer {
        cursor: pointer;
    }

    &.small {
        min-width: 20px;
        min-height: 20px;
    }

    &.medium {
        min-width: 32px;
        min-height: 32px;
    }

    &.big {
        min-width: 40px;
        min-height: 40px;
    }

    &.disabled {
        pointer-events: none;
    }

    &.container {
        display: grid;
        align-content: center;
        justify-content: center;
    }

    &.cross {
        cursor: pointer;
    }
`;

export const LinkStyled = styled.a<IImg>`
    min-width: ${(props) => props.width};
    max-height: ${(props) => props.height};
    ${ImgStyled}
`;

export const StatusStyled = styled.div.attrs({
    className: 'cashback-status',
})`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    .status__title {
        ${fonts.textMainBold}
        margin-top: 16px;
    }

    .status__sub-title {
        margin-top: 8px;
    }

    .status__btn {
        margin-top: 16px;
    }
`;

export const ImgStatusError = styled(ImgStyled).attrs({
    src: themeIcons.statusError,
})`
    width: 110px;
    height: 120px;
`;

export const ImgStatusSuccess = styled(ImgStyled).attrs({
    src: themeIcons.statusSuccess,
})`
    width: 110px;
    height: 120px;
`;
